module.exports = __webpack_public_path__ + "img/jcyj.97bf9aac.png";